import { Stack } from "@mui/material";
import { useAppDispatch } from "helpers/hooks";
import { EmployerSubDomainTopNav } from "layouts/EmployerSubDomainLayout/EmployerSubDomainTopNav";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { getEmployerDetailsByMaskingName } from "store/slices/employer/employer-sub-domain/employer-sub-domain-slice";
import { EmployerSubDomainOutletWrapper } from "./EmployerSubDomain.styled";

export const EmployerSubDomainWrapper = () => {

    const dispatch = useAppDispatch();

    const subdomain = new URL(window.location.href)?.hostname?.split('.')[0];

    // get employer details by subdomain on page load
    useEffect(() => {
        if (subdomain) {
            dispatch(getEmployerDetailsByMaskingName({ maskingName: subdomain }));
        }
    }, [dispatch, subdomain]);

    return (<>
        <Stack height='100vh'>
            <EmployerSubDomainTopNav />
            <EmployerSubDomainOutletWrapper>
                <Outlet />
            </EmployerSubDomainOutletWrapper>
        </Stack>
    </>);
};